var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-loading", {
        attrs: { active: _vm.loading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showCollectCreation,
            scroll: "keep",
            "has-modal-card": "",
            "full-screen": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.showCollectCreation = $event
            },
          },
        },
        [
          _c("collectCreation", {
            attrs: {
              endusers: _vm.selectedEndusers,
              "selected-group": _vm.selectedGroup,
            },
            on: { close: _vm.closeCollectCreation },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "b-field",
            { attrs: { label: "Left panel size" } },
            [
              _c("b-slider", {
                attrs: { size: "is-small", max: 10, step: 0.5 },
                model: {
                  value: _vm.customWidth,
                  callback: function ($$v) {
                    _vm.customWidth = $$v
                  },
                  expression: "customWidth",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "div",
          {
            staticClass: "left-box custom-container",
            style:
              _vm.customWidth > 0
                ? "width: " + _vm.customWidth * 100 + "px"
                : "display: none;",
            attrs: { id: "left-panel" },
          },
          [
            _vm._t("default"),
            _c(
              "div",
              { staticClass: "left-box", staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  { staticClass: "panel", staticStyle: { width: "100%" } },
                  [
                    _vm._m(0),
                    _vm.updatingCoords
                      ? _c("div", { staticClass: "panel-block" }, [
                          _c("span", [
                            _vm._v(
                              " click on the map to choose the new location "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "left-box panel-block" }, [
                      !_vm.updatingCoords
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "button is-info is-medium",
                                attrs: {
                                  disabled: !_vm.markers.find(
                                    (m) => m.selected
                                  ),
                                },
                                on: { click: _vm.switchUpdatingCoords },
                              },
                              [_c("span", [_vm._v(" Update")])]
                            ),
                          ])
                        : _c("div", { staticClass: "left-box" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-warning is-medium",
                                on: { click: _vm.switchUpdatingCoords },
                              },
                              [_c("span", [_vm._v("Cancel")])]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary is-medium",
                                staticStyle: { "margin-top": "10px" },
                                attrs: {
                                  disabled:
                                    !_vm.markers.find((m) => m.newMarker) ||
                                    !_vm.markers.find((m) => m.selected),
                                },
                                on: { click: _vm.updateCoords },
                              },
                              [_c("span", [_vm._v(" Update")])]
                            ),
                          ]),
                    ]),
                  ]
                ),
                _vm.noCoords
                  ? _c(
                      "div",
                      { staticClass: "panel", staticStyle: { width: "100%" } },
                      [
                        _c("div", { staticClass: "panel-heading" }, [
                          _vm._v(" Unplaced "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "panel-block" },
                          [
                            _c("multiselect", {
                              attrs: {
                                options: [
                                  { id: 0, title: "customer" },
                                  { id: 1, title: "enduser" },
                                ],
                                multiple: false,
                                "close-on-select": true,
                                label: "title",
                                "track-by": "title",
                              },
                              model: {
                                value: _vm.typeToPlace,
                                callback: function ($$v) {
                                  _vm.typeToPlace = $$v
                                },
                                expression: "typeToPlace",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "panel-block" },
                          [
                            _vm.typeToPlace
                              ? _c("multiselect", {
                                  attrs: {
                                    options: _vm.getNoCoordsOptions(),
                                    multiple: false,
                                    "close-on-select": true,
                                    "custom-label": (n) => {
                                      return n.id + " - " + n.name
                                    },
                                    "track-by": "name",
                                  },
                                  model: {
                                    value: _vm.selectedNoCoords,
                                    callback: function ($$v) {
                                      _vm.selectedNoCoords = $$v
                                    },
                                    expression: "selectedNoCoords",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.selectedNoCoords
                          ? _c(
                              "div",
                              {
                                staticClass: "panel-blok",
                                staticStyle: { "text-align": "left" },
                              },
                              [
                                _c("span", [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(" Address: "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.selectedNoCoords.address) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _c("span", [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(" City: "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.selectedNoCoords.city) +
                                      " - " +
                                      _vm._s(_vm.selectedNoCoords.postalCode) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _c("span", [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v(" Country: "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.selectedNoCoords.country) +
                                      " "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.selectedNoCoords
                          ? _c("div", { staticClass: "panel-block left-box" }, [
                              _vm._v(" Now click on the map to place it "),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "panel-block left-box" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-info is-medium",
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                disabled:
                                  !_vm.markers.find((m) => m.newMarker) ||
                                  !_vm.selectedNoCoords,
                              },
                              on: { click: _vm.createCoords },
                            },
                            [_c("span", [_vm._v(" Create ")])]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.mapType === "pickup"
                  ? _c(
                      "div",
                      { staticClass: "panel", staticStyle: { width: "100%" } },
                      [
                        _vm._m(1),
                        _c(
                          "b-button",
                          {
                            staticClass: "is-small",
                            attrs: { type: "is-warning" },
                            on: {
                              click: () => {
                                _vm.filteredMarkers = _vm.markers
                              },
                            },
                          },
                          [_vm._v(" Reset ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "panel-block" },
                          [
                            _c("multiselect", {
                              attrs: {
                                options: ["Quantity", "Materials"],
                                multiple: false,
                                "close-on-select": true,
                              },
                              model: {
                                value: _vm.filterType,
                                callback: function ($$v) {
                                  _vm.filterType = $$v
                                },
                                expression: "filterType",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.filterType === "Quantity"
                          ? _c(
                              "div",
                              { staticClass: "left-box panel-block" },
                              [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: `Any quantity ≥ ${
                                        _vm.quantityFilter
                                          ? _vm.quantityFilter
                                          : ""
                                      }`,
                                    },
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        placeholder: "Enter a minimum quantity",
                                      },
                                      model: {
                                        value: _vm.quantityFilter,
                                        callback: function ($$v) {
                                          _vm.quantityFilter = $$v
                                        },
                                        expression: "quantityFilter",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.filterType === "Materials"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-radio",
                                      {
                                        attrs: {
                                          name: "name",
                                          "native-value": "And",
                                        },
                                        model: {
                                          value: _vm.matFilterComparisonType,
                                          callback: function ($$v) {
                                            _vm.matFilterComparisonType = $$v
                                          },
                                          expression: "matFilterComparisonType",
                                        },
                                      },
                                      [_vm._v(" And ")]
                                    ),
                                    _c(
                                      "b-radio",
                                      {
                                        attrs: {
                                          name: "name",
                                          "native-value": "Or",
                                        },
                                        model: {
                                          value: _vm.matFilterComparisonType,
                                          callback: function ($$v) {
                                            _vm.matFilterComparisonType = $$v
                                          },
                                          expression: "matFilterComparisonType",
                                        },
                                      },
                                      [_vm._v(" Or ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "panel-block d-flex-space-evenly",
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "is-small",
                                            attrs: { type: "is-primary" },
                                            on: {
                                              click: () => {
                                                _vm.matFilters.push({
                                                  mat: "",
                                                  qty: "",
                                                })
                                              },
                                            },
                                          },
                                          [_vm._v("Add material filter")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._l(_vm.matFilters, function (f, index) {
                                  return _c("div", { key: index }, [
                                    _c("div", { staticClass: "separator" }),
                                    _c(
                                      "div",
                                      { staticClass: "left-box panel-block" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeFilter(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              staticClass:
                                                "pull-right custom-quit-cross",
                                              attrs: {
                                                icon: "times",
                                                size: "is-small",
                                                type: "is-danger",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("multiselect", {
                                          attrs: {
                                            options: _vm.materials,
                                            multiple: false,
                                            "close-on-select": true,
                                            "custom-label": (n) =>
                                              n.MATNR + " - " + n.MAKTX,
                                            "track-by": "MATNR",
                                          },
                                          model: {
                                            value: f.mat,
                                            callback: function ($$v) {
                                              _vm.$set(f, "mat", $$v)
                                            },
                                            expression: "f.mat",
                                          },
                                        }),
                                        _c(
                                          "b-field",
                                          {
                                            attrs: {
                                              label: `${
                                                f.mat ? f.mat.MATNR + " ≥ " : ""
                                              } ${f.qty ? f.qty : ""}`,
                                            },
                                          },
                                          [
                                            _c("b-input", {
                                              attrs: {
                                                placeholder:
                                                  "Enter a minimum quantity",
                                              },
                                              model: {
                                                value: f.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(f, "qty", $$v)
                                                },
                                                expression: "f.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                }),
                                _vm.matFilters.length > 0
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { type: "is-info" },
                                        on: { click: _vm.submitMatFilters },
                                      },
                                      [_vm._v(" Search ")]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.mapType === "pickup"
                  ? _c(
                      "div",
                      { staticClass: "panel", staticStyle: { width: "100%" } },
                      [
                        _vm._m(2),
                        _c(
                          "div",
                          { staticClass: "left-box panel-block" },
                          [
                            !_vm.makingGroupedCollect
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: { type: "is-info" },
                                    on: {
                                      click: () => {
                                        _vm.makingGroupedCollect = true
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(" Make grouped collect "),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "b-button",
                                  {
                                    attrs: { type: "is-warning" },
                                    on: {
                                      click: _vm.cancelMakingGroupedCollect,
                                    },
                                  },
                                  [_c("span", [_vm._v(" Cancel ")])]
                                ),
                          ],
                          1
                        ),
                        _vm.makingGroupedCollect
                          ? _c(
                              "div",
                              { staticClass: "left-box panel-block" },
                              [
                                _c("div", [
                                  _vm._v(" Please select desired endusers "),
                                ]),
                                _c("div", [_vm._v(" Selected endusers : ")]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._l(
                                  _vm.filteredMarkers.filter((f) => f.selected),
                                  function (s) {
                                    return _c("div", { key: s.id }, [
                                      _c("span", [
                                        _vm._v(
                                          " °" +
                                            _vm._s(s.enduserCode) +
                                            " - " +
                                            _vm._s(s.enduserName) +
                                            " "
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { type: "is-primary" },
                                    on: { click: _vm.submitGroupedCollect },
                                  },
                                  [_c("span", [_vm._v(" Submit ")])]
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ],
          2
        ),
        _c(
          "div",
          {
            staticStyle: { height: "93vh", width: "100%" },
            attrs: { id: "gps-map" },
          },
          [
            _c(
              "l-map",
              {
                ref: "mapRef",
                staticStyle: { "z-index": "10" },
                attrs: {
                  "world-copy-jump": true,
                  zoom: _vm.zoom,
                  "min-zoom": 3,
                  center: _vm.center,
                  bounds: _vm.computedBounds,
                },
                on: {
                  "update:zoom": _vm.zoomUpdated,
                  "update:center": _vm.centerUpdated,
                  "update:bounds": _vm.boundsUpdated,
                  ready: _vm.mapReady,
                  click: _vm.mapClick,
                },
              },
              [
                _c("l-tile-layer", { attrs: { url: _vm.url } }),
                _c(
                  "l-control",
                  { attrs: { position: "bottomright" } },
                  [
                    _c("map-legend", {
                      staticClass: "box is-hidden-touch",
                      attrs: { id: "legend", "map-type": _vm.mapType },
                    }),
                  ],
                  1
                ),
                _vm.filteredMarkers
                  ? _c(
                      "l-marker-cluster",
                      { attrs: { options: _vm.clusterOptions } },
                      _vm._l(_vm.filteredMarkers, function (marker) {
                        return _c(
                          "l-marker",
                          {
                            key: marker.mapMarker.id,
                            attrs: {
                              "lat-lng": marker.mapMarker.getLatLng(),
                              icon: marker.mapMarker.getIcon(),
                            },
                            on: {
                              mouseover: marker.hoverEvent,
                              click: _vm.selectMarker,
                            },
                          },
                          [
                            _c(
                              "l-tooltip",
                              { attrs: { options: { sticky: true } } },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(marker.id || marker.enduserCode)
                                  ),
                                ]),
                                _c("br"),
                                _c("b", [_vm._v(_vm._s(marker.name))]),
                                _c("br"),
                                _vm._v(_vm._s(marker.city) + " "),
                                _c("br"),
                                _vm._v(_vm._s(marker.country) + " "),
                                marker.lastInventory &&
                                marker.lastInventory.length > 0
                                  ? _c(
                                      "div",
                                      [
                                        _c("span", [_vm._v("-------")]),
                                        _c("br"),
                                        _c("b", [
                                          _vm._v("Materials declaration :"),
                                        ]),
                                        _vm._v(" "),
                                        _c("br"),
                                        marker.lastInventory &&
                                        marker.lastInventory.length > 0 &&
                                        marker.lastInventory[0].date
                                          ? _c("span", [
                                              _vm._v(
                                                "Made on " +
                                                  _vm._s(
                                                    _vm
                                                      .$dayjs(
                                                        marker.lastInventory[0]
                                                          .date
                                                      )
                                                      .local()
                                                      .format("DD/MM/YYYY")
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._l(
                                          marker.lastInventory,
                                          function (q) {
                                            return _c(
                                              "div",
                                              { key: q.material },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(q.material) +
                                                    " : " +
                                                    _vm._s(q.inventory) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                marker.lastCollect && marker.lastCollect.length
                                  ? _c(
                                      "div",
                                      [
                                        _c("span", [_vm._v("-------")]),
                                        _c("br"),
                                        _c("b", [_vm._v("Last collect :")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        marker.lastCollect[0].loadingDate
                                          ? _c("span", [
                                              _vm._v(
                                                "Made on " +
                                                  _vm._s(
                                                    _vm
                                                      .$dayjs(
                                                        marker.lastCollect[0]
                                                          .loadingDate
                                                      )
                                                      .local()
                                                      .format("DD/MM/YYYY")
                                                  )
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._l(
                                          marker.lastCollect,
                                          function (q, index) {
                                            return _c("div", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(q.mat) +
                                                  " : " +
                                                  _vm._s(q.qty) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-heading" }, [
      _c("span", [_vm._v(" Update location ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-heading" }, [
      _c("span", [_vm._v(" Filters ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-heading" }, [
      _c("span", [_vm._v(" Grouped collect ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }